
    import Component from "vue-class-component";
    import Vue from "vue";
    import {
      ApplicationActions, ApplicationHistoryEventModel,
      ApplicationViewModel,
      CertificateRequirementViewModel, DuplicationReasonRequirementViewModel,
      factory, FilesRequirementViewModel,
      MedicalCertificateRequirementViewModel,
      PersonalInfoRequirementViewModel, PositionsRequirementViewModel, PracticesRequirementViewModel,
      QualificationRequirementViewModel,
      RequirementFulfillmentViewModel, RequirementsClient,
      RequirementViewModel,
      ResultError, StateFeeRequirementViewModel,
      PersonalInfoClient, PersonalInfoModel
    } from "@/api-client";
    import {Prop} from "vue-property-decorator";
    import QualificationRequirement from "@/features/applications/components/requirements/QualificationRequirement.vue";
    import RequirementProcessing from "@/features/applications/components/RequirementProcessing.vue";
    import SectionRequirements from "@/features/applications/components/SectionRequirements.vue";
    import SectionRequirementHeading from "@/features/applications/components/SectionRequirementHeading.vue";
    import CertificateRequirement from "@/features/applications/components/requirements/CertificateRequirement.vue";
    import PersonalInfoRequirement from "@/features/applications/components/requirements/PersonalInfoRequirement.vue";
    import MedicalCertificateRequirement from "@/features/applications/components/requirements/MedicalCertificateRequirement.vue";
    import PositionsRequirement from "@/features/applications/components/requirements/PositionsRequirement.vue";
    import PracticesRequirement from "@/features/applications/components/requirements/PracticesRequirement.vue";
    import FilesRequirement from "@/features/applications/components/requirements/FilesRequirement.vue";
    import StateFeeRequirement from "@/features/applications/components/requirements/stateFee/StateFeeRequirement.vue";
    import RequirementValueChangeComment from "@/features/applications/components/RequirementValueChangeComment.vue";
    import RequirementProcessingDecision from "@/features/applications/components/RequirementProcessingDecision.vue";
    import ApplicationHistory from "@/features/applications/components/history/ApplicationHistory.vue";
    import DuplicationReasonRequirement from "@/features/applications/components/requirements/DuplicationReasonRequirement.vue";
    import ErrorsSummary from "@/components/ErrorsSummary.vue";

    @Component({
        components: {
            ErrorsSummary,
            RequirementProcessing,
            QualificationRequirement,
            CertificateRequirement,
            PersonalInfoRequirement,
            SectionRequirements,
            SectionRequirementHeading,
            MedicalCertificateRequirement,
            PositionsRequirement,
            PracticesRequirement,
            FilesRequirement,
            StateFeeRequirement,
            RequirementValueChangeComment,
            RequirementProcessingDecision,
            DuplicationReasonRequirement,
            ApplicationHistory
        }
    })
    export default class RequirementOverview extends Vue {
        @Prop({required: true})
        application!: ApplicationViewModel;
        @Prop({required: true})
        actions!: ApplicationActions;
        @Prop({required: true})
        historyEvents!: ApplicationHistoryEventModel[];

        requirementFulfillment: RequirementFulfillmentViewModel | null = null;
        requirement: RequirementViewModel | null = null;
        componentName: string | null = null;
        headingDescription: string | null = null;
        customHeader: string | null = null;
        requirementDescriptionTitle: string | null = null;
        errors: ResultError = factory.create(ResultError);
        additionalInfo: string[] = [];
        personalInfo: PersonalInfoModel | null = null;

        async created() {
            const requirementId = this.$route.params.requirementId;
            const requirementFulfillment = this.application.requirementFulfillments.find(x => x.requirementId == requirementId);
            if (!requirementFulfillment)
                throw "Requirement not found.";

            this.requirementFulfillment = requirementFulfillment;
            this.requirement = requirementFulfillment.requirement;
            this.personalInfo = await new PersonalInfoClient().get(this.application.seafarerId);

            if (this.requirement instanceof QualificationRequirementViewModel) {
                this.headingDescription = QualificationRequirement.headingDescription;
                this.requirementDescriptionTitle = QualificationRequirement.requirementDescriptionTitle;
                this.componentName = "QualificationRequirement";
            }
            else if (this.requirement instanceof CertificateRequirementViewModel) {
                this.headingDescription = CertificateRequirement.headingDescription;
                this.requirementDescriptionTitle = CertificateRequirement.requirementDescriptionTitle
                this.componentName = "CertificateRequirement";
            }
            else if (this.requirement instanceof MedicalCertificateRequirementViewModel) {
                this.headingDescription = MedicalCertificateRequirement.headingDescription;
                this.requirementDescriptionTitle = MedicalCertificateRequirement.requirementDescriptionTitle
                this.componentName = "MedicalCertificateRequirement";
            }
            else if (this.requirement instanceof PositionsRequirementViewModel) {
                this.headingDescription = PositionsRequirement.headingDescription;
                this.componentName = "PositionsRequirement";
            }
            else if (this.requirement instanceof PersonalInfoRequirementViewModel) {
                this.requirementDescriptionTitle = PersonalInfoRequirement.requirementDescriptionTitle;
                this.componentName = "PersonalInfoRequirement";
            }
            else if (this.requirement instanceof PracticesRequirementViewModel) {
              this.headingDescription = PracticesRequirement.headingDescription;
              this.requirementDescriptionTitle = PracticesRequirement.requirementDescriptionTitle;
              this.componentName = "PracticesRequirement";
            }
            else if (this.requirement instanceof FilesRequirementViewModel) {
              this.requirementDescriptionTitle = FilesRequirement.requirementDescriptionTitle;
              this.componentName = "FilesRequirement";
            }
            else if (this.requirement instanceof StateFeeRequirementViewModel) {
              this.headingDescription = StateFeeRequirement.headingDescription;
              this.requirementDescriptionTitle = StateFeeRequirement.requirementDescriptionTitle;
              this.componentName = "StateFeeRequirement";
            }
            else if (this.requirement instanceof DuplicationReasonRequirementViewModel) {
              this.headingDescription = DuplicationReasonRequirement.headingDescription;
              this.requirementDescriptionTitle = DuplicationReasonRequirement.requirementDescriptionTitle;
              this.componentName = "DuplicationReasonRequirement";
            }
            else {
                throw "Unknown requirement.";
            }
        }

        get requirementHistoryEvents(){
            if (!this.requirement)
                return [];
            return this.historyEvents.filter(x => x.requirementId === this.requirement!.id)
        }

        customHeaderChanged(header: string) {
            this.customHeader = header;
        }
        handleError(errors: ResultError, additionalInfo: string[] = []) {
          this.errors = errors
          this.additionalInfo = additionalInfo;
        }

        async submitRequirementValueChangeComment(comment: string) {
          await new RequirementsClient()
            .submitRequirementValueChangeComment(comment, this.application!.id, this.requirement!.id)
              .then(
                  () => this.$emit('application-changed'),
                  error => this.handleError(error));
        }
    }
